import * as yup from 'yup'

// SC-10941: com o cartão na Stone, o recebedor exige complemento e ponto de
// referência em todo endereço (vazio é recusado), e na PJ um endereço do sócio.
const forStone = (message: string) =>
  yup.string().when('isStone', {
    is: true,
    then: yup.string().required(message),
    otherwise: yup.string()
  })

const forStonePartner = (message: string) =>
  yup.string().when(['isStone', 'isCNPJ', 'owner_same_as_company'], {
    is: (isStone?: boolean, isCNPJ?: boolean, same?: boolean) =>
      !!isStone && !!isCNPJ && !same,
    then: yup.string().required(message),
    otherwise: yup.string()
  })

export const schemaAddressForm = yup.object({
  street: yup.string().required('Rua obrigatório.'),
  number: yup.string().required('Número obrigatório.'),
  complement: forStone('Complemento obrigatório (ex.: Casa, Sala 2).'),
  neighborhood: yup.string().required('Bairro obrigatório.'),
  city: yup.string().required('Cidade obrigatório.'),
  postal_code: yup.string().required('CEP obrigatório.'),
  reference_point: forStone('Ponto de referência obrigatório.'),
  isStone: yup.boolean(),
  isCNPJ: yup.boolean(),
  owner_same_as_company: yup.boolean(),
  owner_postal_code: forStonePartner('CEP do sócio obrigatório.'),
  owner_street: forStonePartner('Rua do sócio obrigatória.'),
  owner_number: forStonePartner('Número do endereço do sócio obrigatório.'),
  owner_complement: forStonePartner(
    'Complemento do endereço do sócio obrigatório.'
  ),
  owner_neighborhood: forStonePartner('Bairro do sócio obrigatório.'),
  owner_city: forStonePartner('Cidade do sócio obrigatória.'),
  owner_reference_point: forStonePartner(
    'Ponto de referência do endereço do sócio obrigatório.'
  )
})

export type AddressFormSchema = yup.InferType<typeof schemaAddressForm>
